const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.ogestyle.com";

const DEFAULT_COUNTRY_CODE = "us";

let countryCodePromise = null;

function normalizeCountryCode(rawValue) {
  const cleaned = String(rawValue || "").trim().toLowerCase();
  if (!/^[a-z]{2}$/.test(cleaned)) {
    return DEFAULT_COUNTRY_CODE;
  }
  return cleaned;
}

export function getDefaultAddressCountryCode() {
  return normalizeCountryCode(
    process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_COUNTRY_CODE ||
      process.env.REACT_APP_DEFAULT_COUNTRY ||
      DEFAULT_COUNTRY_CODE,
  );
}

export async function getAddressAutocompleteCountryCode() {
  if (countryCodePromise) {
    return countryCodePromise;
  }

  countryCodePromise = (async () => {
    const fallback = getDefaultAddressCountryCode();

    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/settings/public`);
      if (!response.ok) {
        return fallback;
      }

      const data = await response.json();
      const configuredValue =
        data?.settings?.homepageSettings?.addressAutocompleteCountryCode;

      return normalizeCountryCode(configuredValue || fallback);
    } catch {
      return fallback;
    }
  })();

  return countryCodePromise;
}
